import { useApiService } from '~/services/api'

export default {
  props: {
    filters: {
      type: Object,
    },
    emptyPositionsText: {
      type: String,
    },
    gtm: {
      type: Object,
    },
  },

  data() {
    return {
      query: {
        offices: '',
        keywords: this.$route.query.search?.replace(' ', ','),
        search: this.$route.query.search,
        limit: 1000,
      },
      offices: [],
      positions: [],
      loadingData: true,
      hasResults: true,
      locale: this.$i18n.locale,
      lang: this.$i18n.locale.slice(0, 2),
    }
  },

  async fetch() {
    await this.setOffices()

    await this.updateApiDb()

    Promise.resolve(this.setQuery())
    await this.updatePositions()
  },

  watch: {
    async query(newValue, oldValue) {
      if (newValue.offices.length !== oldValue.offices.length) {
        Promise.resolve(this.setQuery())
        await this.updatePositions()
      }
    },

    async '$route.query.search'(newValue, oldValue) {
      if (newValue !== oldValue) {
        Promise.resolve(this.setQuery())
        await this.updatePositions()
      }
    },
  },

  computed: {
    officesForSelectAccordion() {
      return this.offices.map((office) => {
        const officeLocalizedInfo = office[this.lang]

        return {
          label: `${officeLocalizedInfo.city}, ${officeLocalizedInfo.country}`,
          value: office.providerId,
        }
      })
    },
  },

  methods: {
    async updateApiDb() {
      if (this.$route.query.update) {
        await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: '/sync',
        })
      }
    },

    async setOffices() {
      const { _embedded } = await useApiService({
        api: 'apiJobs',
        endpoint: 'offices',
      })
      this.offices = _embedded.offices || []
    },

    setQuery(offices) {
      const search = this.$route.query.search || ''

      this.query.keywords = search?.replace(' ', ',')
      this.query.offices = offices?.toString() || ''
      this.query.search = search
    },

    async updatePositions() {
      try {
        this.loadingData = true

        const { _embedded } = await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: '/find',
          params: {
            locale: 'es,pt,en',
            title: this.query.search,
            ...this.query,
          },
        })
        this.positions = this.setOfficesName(_embedded.jobs) || []

        this.loadingData = false
      } catch (error) {
        this.loadingData = true

        const result = await useApiService({
          api: 'apiJobsExternalProvider',
          endpoint: 'jobs',
          locale: this.lang,
          params: {
            locale: this.lang,
            title: this.query.search,
            ...this.query,
          },
        })
        this.positions = result || []

        this.loadingData = false
      }
    },

    setOfficesName(jobs) {
      return (jobs || []).map((job) => {
        if (!job.office) {
          return job
        }

        return {
          ...job,
          office: this.getOfficeName(job.office),
        }
      })
    },

    getOfficeName(officeId) {
      const office = (this.offices || []).find(
        (officeData) => officeData.providerId.toString() === officeId.toString()
      )
      const locale = this.lang

      return office ? `${office[locale].country}, ${office[locale].city}` : ''
    },

    async onSelectOffices(selectedOffices) {
      Promise.resolve(this.setQuery(selectedOffices))
      await this.updatePositions()
    },
  },
}
